import ContentPage from './ContentPage';

export default function TermsPage() {
  return (
    <ContentPage
      eyebrow="Legal"
      title="Terms & Conditions"
      lead="The ground rules for using the Nayavarnam store and placing orders with us."
    >
      <section>
        <h3>Using the site</h3>
        <p>
          By browsing or creating an account, you agree to use Nayavarnam for personal shopping,
          provide accurate details, and keep your login secure. We may update products, prices, and
          availability without prior notice.
        </p>
      </section>
      <section>
        <h3>Orders</h3>
        <p>
          Adding items to your bag and submitting checkout details is a request to purchase. Final
          confirmation, payment instructions, and delivery timelines are shared through our team
          (including WhatsApp) after review. We reserve the right to decline or cancel orders that
          cannot be fulfilled.
        </p>
      </section>
      <section>
        <h3>Product information</h3>
        <p>
          We aim for accurate descriptions, colours, and imagery. Slight variations can occur due to
          lighting, craft, or screen settings. Size charts, where available, are guides — please
          measure carefully.
        </p>
      </section>
      <section>
        <h3>Accounts & sessions</h3>
        <p>
          You are responsible for activity under your account. Sessions may expire for security;
          sign in again to continue. Misuse of the site may result in restricted access.
        </p>
      </section>
      <section>
        <h3>Changes</h3>
        <p>
          These terms may be updated as the store evolves. Continued use of the site after changes
          means you accept the revised terms. For questions, contact us through the home page.
        </p>
      </section>
    </ContentPage>
  );
}
